var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'websliderInspiration';

var	DEFAULTS = {
	'json': typeof sliderSource != 'undefined' ? sliderSource : null,
	'messages': {
		'cs': {
			'moreInfo': 'Více informací'
		},
		'de': {
			'moreInfo': 'Mehr Informationen'
		},
        'en': {
			'moreInfo': 'More information'
        },
		'pl': {
			'moreInfo': 'Więcej informacji'
		},
        'sk': {
			'moreInfo': 'Viac informácií'
        },
		'fr': {
			'moreInfo': 'Plus d information'
		}
	},
	'lang': $('html').attr('lang')
};


/**
 * constructor
 * @param selector
 * @param options
 * @constructor
 */
var WebsliderInspiration = function (selector, options) {
	this.$t = $(selector);

	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.data = {};
	this.objects = {};
	this.animating = false;
	this.previousEvent = '';

	this.initialise_();
};

/**
 * init funkce
 * @private
 */
WebsliderInspiration.prototype.initialise_ = function() {
	var self = this;

	self.getData_();

	if (self.data.length > 0) {
		self.objects.$preloader = self.$t.find('.preloader');
		self.buildHtml_();
		self.bindEvents_();
	}
};

WebsliderInspiration.prototype.getData_ = function() {
	var self = this;
	self.data = self.options.json;
};

WebsliderInspiration.prototype.buildHtml_ = function() {
	var self = this;
	if (self.data.length > 1) {
		self.buildHtmlThumbnailsWrapper_();
	}
	self.buildHtmlContent_();
};


WebsliderInspiration.prototype.buildHtmlThumbnailsWrapper_ = function() {
	var self = this;

	self.objects.$slideThumbnails = $('<div class="thumbnails-wrapper" />');
	self.objects.$slideThumbnailsList = $('<ul />');
	self.$t.append(self.objects.$slideThumbnails);
	self.objects.$slideThumbnails.append(self.objects.$slideThumbnailsList);
};

WebsliderInspiration.prototype.buildHtmlContent_ = function() {
	var self = this,
		item,
		thumbnailClass,
		espPopup,
		slideClass,
		html = '',
		$mainMotiveSlide;

	self.objects.$slideWrapper = self.$t.find('.slide-wrapper');

	for (var i in self.data) {
		item = self.data[i];
		thumbnailClass = '';
		slideClass = '';
		espPopup = '';

		if (i == 0) {
			thumbnailClass = 'active ';
		}

		if (item.type == 'mainMotive') {
			$mainMotiveSlide = self.objects.$slideWrapper.find('.slide');
			$mainMotiveSlide.attr('data-item-id', i);
			self.buildHtmlProducts_($mainMotiveSlide, item.data);
		}
		else {
			slideClass = ` ${item.type}`;
			//slideClass = item.type == 'video' ? ' video' : '';

			html = '<div class="slide' + slideClass + '" data-item-id="' + i + '">';
			if (item.type == 'galleryItem') {
				html += '<picture><img src="' + item.src + '" alt="" width="1600" height="580" /></picture>';
			}
			else if (item.type == 'video') {
				espPopup = ` class="js_esp-trigger" data-action="pushFgWebAnalytics" data-action-trigger="click" data-action-var-act="WatchVideo" data-action-var-lbl="www.youtube.com/embed/${item.videoCode}" data-esp-class-name="esp__target--youtube" data-esp-trigger-event="click" data-esp-content-type="iframe" data-esp-type="fixed" data-esp-target="https://www.youtube.com/embed/${item.videoCode}?enablejsapi=1&rel=0&fs=0&autoplay=1"`;
				thumbnailClass += 'video';

				html += `<div${espPopup}></div><iframe id="yt-player" type="text/html" width="100%" height="100%" src="https://www.youtube.com/embed/${item.videoCode}?enablejsapi=1" frameborder="0"></iframe>`;
			} else if (item.type == 'panorama') {
				espPopup = ` class="js_esp-trigger" data-esp-class-name="esp__target--pannellum" data-esp-trigger-event="click" data-esp-content-type="iframe" data-esp-type="fixed" data-esp-target="${item.popupUrl}?panorama=${item.srcPanorama}&autoLoad=true&autoRotate=-2"`;
				thumbnailClass += 'panorama';

				html += `<div${espPopup}><span></span></div><picture><img src="${item.src}" alt="" width="1600" height="580" /></picture>`;
			}
			html += '</div>';
			self.objects.$slideWrapper.append(html);
		}

		self.objects.$slides = self.objects.$slideWrapper.find('.slide');

		if (self.data.length > 1) {
			if (thumbnailClass != '') {
				thumbnailClass = ' class="' + thumbnailClass + '"';
			}
			self.objects.$slideThumbnailsList.append('<li' + thumbnailClass + ' data-item-id="' + i + '"><a href="#"><img src="' + item.srcThumb + '" alt="" /><span></span></a></li>');
			self.objects.$thumbnails = self.objects.$slideThumbnailsList.find('li');
			self.objects.$thumbnailsLinks = self.objects.$slideThumbnailsList.find('a');
			self.objects.$ytPlayer = self.objects.$slideWrapper.find('#yt-player');

			setTimeout(function(){
				self.objects.$slideThumbnailsList.addClass('slide-down');
			},1000);
		}
	}
};

WebsliderInspiration.prototype.buildHtmlProducts_ = function($wrapper, data) {
	var self = this,
		item,
		coords,
		img = $wrapper.find('img').get(0),
		imgProduct = '';

	self.objects.$productsList = $('<ul class="point-product-list" />');
	$wrapper.append(self.objects.$productsList);

	for (var i in data) {
		item  = data[i];

		if (item.productLink != null && item.coordinateX != '' && item.coordinateY != '') {
            coords = self.getCoords_(item.coordinateX, item.coordinateY, 1600, 800);
            self.objects.$productsList.append('<li' + coords + '><span class="point"><span class="glyphicon glyphicon-inspirace"></span></span></span><div class="item"><div class="product-info"><h2 class="product-name">' + item.productName + '</h2><p class="product-price">' + item.productPrice + '</p><p class="product-link"><a href="' +  item.productLink + '">'+eval('self.options.messages.'+self.options.lang+'.moreInfo')+'</a></p></div></div></li>');
		}
	}
	self.objects.$products = self.objects.$productsList.find('li');
};

WebsliderInspiration.prototype.getCoords_ = function(x, y, imgWidth, imgHeight) {
	var self = this,
		relativeX,
		relativeY;

	x = parseInt(x.replace(',','.'));
	y = parseInt(y.replace(',','.'));

	if ((imgWidth > 0) && (imgHeight > 0)) {
		relativeX = (x * 100) / imgWidth;
		relativeY = (y * 100) / imgHeight;
	}
	else {
		relativeX = x;
		relativeY = y;
	}

	return ' style="left: ' + relativeX + '%; top: ' + relativeY + '%"';
};

WebsliderInspiration.prototype.bindEvents_ = function() {
	var self = this;

	if (self.data.length > 1) {
		self.objects.$thumbnailsLinks.on('click', function (e) {
			e.preventDefault();
			self.setActiveSlide_($(this).parents('li').attr('data-item-id'));
		});
	}
	self.objects.$products.on('mouseenter', function(e){
		self.toggleProduct_($(this), e);
	});
	self.objects.$products.on('click', function(e){
		self.toggleProduct_($(this), e);
	});
	self.objects.$products.on('mouseleave', function(e){
		self.toggleProduct_($(this), e);
	});
	self.objects.$slides.children('img, iframe').on('load', function(){
		var $this = $(this),
			thisItemId = $this.parents('.slide').attr('data-item-id');

		$this.attr('data-loaded',true);

		if (self.preloaderReasonId == thisItemId) {
			self.finishSettingActiveSlide_(self.preloaderReasonId);
		}
	});
};

WebsliderInspiration.prototype.setActiveSlide_ = function(id) {
	var self = this,
		$currentTarget = self.objects.$slides.filter('.active'),
		currentTargetId = $currentTarget.attr('data-item-id'),
		$newTarget = self.objects.$slides.filter('[data-item-id='+ id +']');

	if ((id != currentTargetId) && (!self.animating)) {
		// stop yt video playback
		if (self.objects.$ytPlayer.length > 0) {
			var frame = self.objects.$ytPlayer.get(0);
			frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		}

		// if ($newTarget.children('img, iframe').is('[data-loaded]')) {
		if ($newTarget.children('img, iframe')) {
			self.finishSettingActiveSlide_(id);
		}
		else {
			self.startPreloader_(id);
		}
	}
};

WebsliderInspiration.prototype.finishSettingActiveSlide_ = function(id) {
	var self = this,
		$currentTarget = self.objects.$slides.filter('.active'),
		currentTargetId = $currentTarget.attr('data-item-id'),
		$newTarget = self.objects.$slides.filter('[data-item-id='+ id +']'),
		animatingClass = 'animating-from-right';

	self.animating = true;

	if (self.preloaderReasonId > -1) {
		self.endPreloader_();
	}

	if (id < currentTargetId) {
		animatingClass = 'animating-from-left';
	}

	self.objects.$thumbnails.removeClass('active').filter('[data-item-id=' + id + ']').addClass('active');
	$newTarget.addClass(animatingClass);
	$newTarget.one('animationend webkitAnimationEnd oAnimationEnd', function () {
		$currentTarget.removeClass('active');
		$newTarget.removeClass(animatingClass).addClass('active');
		self.animating = false;
	});
};

WebsliderInspiration.prototype.toggleProduct_ = function($element, e) {
	var self = this,
		$item = $element.find('.item'),
		itemWidth,
		itemHeight,
		itemOffsetLeft,
		itemOffsetTop,
		wrapperWidth,
		wrapperHeight;

	if (e.type == 'mouseenter') {
		if ($element.hasClass('active')) {
			self.previousEvent = 'noHide';
		}
		else {
			$element.addClass('active');
			self.previousEvent = 'mouseenter';
		}
	}
	else if (e.type == 'click') {
		if ($element.hasClass('active') && self.previousEvent != 'mouseenter' || self.previousEvent == 'noHide') {
			$element.removeClass('active');
		}
		else {
			$element.addClass('active');
		}

		self.previousEvent = 'click';
	}
	else if (e.type == 'mouseleave') {
		if (self.previousEvent != 'click' && self.previousEvent != 'noHide'){
			$element.removeClass('active');
		}

		self.previousEvent = 'mouseleave';
	}

	$element.removeClass('active-left active-top');

	if ($element.hasClass('active')) {
		itemWidth = $item.outerWidth(true);
		itemHeight = $item.outerHeight(true);
		itemOffsetLeft = $item.parents('li').position().left;
		itemOffsetTop = $item.parents('li').position().top;
		wrapperWidth = $item.parents('li').parent().width();
		wrapperHeight = $item.parents('li').parent().height();

		if ((itemOffsetLeft + itemWidth) >= wrapperWidth) {
			$element.addClass('active-left');
		}
		if ((itemOffsetTop + itemHeight) >= wrapperHeight) {
			$element.addClass('active-top');
		}
	}
};

WebsliderInspiration.prototype.startPreloader_ = function(reasonId) {
	var self = this;
	self.objects.$preloader.show();
	self.preloaderReasonId = reasonId;
};
WebsliderInspiration.prototype.endPreloader_ = function() {
	var self = this;
	self.objects.$preloader.hide();
	self.preloaderReasonId = null;
};


/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new WebsliderInspiration(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.webslider-inspiration.js